import React, { Component } from 'react';
import { casinoIdStatus } from 'shared/api/PlayerInfoConstants';
import { REG_EXP } from 'shared/constants';
import SCustomerSupport from 'shared/screens/Settings/CustomerSupport';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import AutoForm from '../../components/Form';
import ImageBW from '../../components/ImageBoundsWrapper';
const CustomerSupportForm = require(asset`forms/customerSupport.form`);

export default class CustomerSupport extends Component {
  render() {
    const activeBG = require(asset`RoundedRect_Pink@2x.png`);
    const sendMessageImage = require(asset`./images/Settings/Send_Message_Icon@3x.png`);

    const success = (
      <p className="popup-message-text">
        {getText(TEXT_KEY.MESSAGE_SUCCESSFULLY_SENT)}
        <br />
        {getText(TEXT_KEY.WE_WILL_GET_BACK_TO_YOU)}
      </p>
    );

    const error = (
      <p className="popup-message-text">
        {getText(TEXT_KEY.SOMETHING_WENT_WRONG)}
        <br />
        {getText(TEXT_KEY.TRY_AGAIN_OR_CONTACT_SUPPORT)}
      </p>
    );

    const guestMessage = (
      <p className="popup-message-text">
        {getText(TEXT_KEY.PLEASE_SUBMIT_A_REQUEST)}
        <a target="_blank" style={{ color: '#561F9E' }} href={ENVIRONMENT_VARIABLES.ZENDESK_URL}>
          {getText(TEXT_KEY.SUPPORT_PORTAL)}
        </a>
      </p>
    );

    return (
      <SCustomerSupport
        {...this.props}
        navigation={this.props.navigation}
        CustomerSupportForm={CustomerSupportForm}
        render={args => {
          const { layout, messageResponse, responseSuccess, submitSupportMessage, propsCasinoIdStatus, isGuest } = args;

          const { goBackHandler, onShowPopUp, showPopUp, screensEnum, email } = this.props;

          const showPopUpHandler = success => {
            onShowPopUp(success ? screensEnum.messageSent : screensEnum.messageSentError);
          };

          const hasTestEmail = REG_EXP.validTestEmail.test(email);

          return isGuest || propsCasinoIdStatus === casinoIdStatus.GUEST || hasTestEmail ? (
            <div className="popup-content-container" style={{ paddingBottom: '10vmin' }}>
              <div>{guestMessage}</div>
            </div>
          ) : (
            <>
              {!showPopUp ? (
                <AutoForm
                  layout={layout}
                  prev={goBackHandler}
                  next={() => {
                    submitSupportMessage(showPopUpHandler);
                  }}
                  serverResponse={messageResponse}
                  customStyle={{
                    bottom: '0.8rem',
                    left: '1rem',
                    right: '1rem',
                  }}
                  formCustomContent
                  customConfirmButton
                  hideTopBar
                />
              ) : (
                <div className="popup-content-container" style={{ paddingBottom: '10vmin' }}>
                  <div>
                    <div className="sent-message-image-container" onClick={goBackHandler}>
                      <ImageBW
                        source={sendMessageImage}
                        ibw={require(asset`./images/Settings/Send_Message_Icon.ibw`)}
                        style={{ objectFit: 'contain' }}
                        className="sent-message-image"
                        innerStyle={{
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                    {responseSuccess ? success : error}
                  </div>
                  <div
                    className="done-button-container"
                    style={{
                      position: 'absolute',
                      bottom: '0.8rem',
                      left: '1rem',
                      right: '1rem',
                    }}
                    onClick={goBackHandler}
                  >
                    <ImageBW
                      source={activeBG}
                      ibw={require(asset`Confirm_Button.ibw`)}
                      style={{ objectFit: 'contain' }}
                      className="done-button-background-image"
                      innerStyle={{
                        cursor: 'pointer',
                      }}
                    >
                      <div className="done-button-content">
                        <span className="done-button-text" data-label="DONE">
                          {getText(TEXT_KEY.DONE)}
                        </span>
                      </div>
                    </ImageBW>
                  </div>
                </div>
              )}
            </>
          );
        }}
      />
    );
  }
}

